import angular from 'angular';
import { MeurhArquivosTrabalhadorIndexController } from './index/arquivos.trabalhador.index.controller';

export class MeurhArquivosTrabalhadorComponent implements angular.IComponentOptions {
    static selector = 'meurhArquivosTrabalhadorComponent';
    static controller = MeurhArquivosTrabalhadorIndexController;
    static template = require('!!html-loader!./index/arquivos.trabalhador.index.html');
    static transclude = true;
    static bindings = {
        colaborador: '<'
    };
}
